import React, {useEffect, useState} from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin,
  message,
} from "antd";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {InputFields} from "components/common";
import {dataFields} from "./config";
import {employeeService} from "api"

import {
  setEmployee,

} from "redux/reducer/employee";
import Notification from "../../../../../../components/common/notification/notification";
import dayjs from "dayjs";
import {dataFields as inputFieldsInit} from "./config";
import { RangePickerProps } from "antd/es/date-picker";

const FormAdd = props => {
  const {data, closeModal, type, getListApi, setCurrentPage} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [code, setCode] = useState(null);
  const employeesStore = useAppSelector(
      (state) => state.employeesReducer.employee
  );
  const [fieldInfo, setFieldInfo] = useState(inputFieldsInit);
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
      const endDay = form.getFieldValue("thoiGianApDungDen");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
      const start = form.getFieldValue("thoiGianApDungTu");
      if (start) {
        return currentDate < start;
      }
    };
    inputFieldsInit.find(e => e.name == "thoiGianApDungTu").disabledDate = disabledDateStart;
    inputFieldsInit.find(e => e.name == "thoiGianApDungDen").disabledDate = disabledDateEnd;
    setFieldInfo([...inputFieldsInit]);
  }, []);
  const dispatch = useAppDispatch();
  useEffect(() => {
    setLoading(true);
    if (type == "Thêm") {
      newId();
      setLoading(false);
      form.resetFields();
      form.setFieldValue("maCauHinh",code);
    } else {
      setLoading(false);
      form.setFieldsValue(data);
    }

  }, [data,code]);
  const newId = async () => {
    try {
      const res = await employeeService.getNewIdCauHinhLuong();
      setCode(res);
    } catch (error) {
      Notification("error", "Đã có lỗi khi lấy mã cấu hình lương");
    }
  };

  const addApi = async () => {
    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(), // Lấy giá trị từ form
      };
      await employeeService.updateCauHinhLuong(params).then(res => {
        if(res.statusCode === 400)
        {
          Notification("error",res.message);
          newId();
        }else
        {
          Notification("success","Đã thêm mới cấu hình lương thành công");
        }
      });
      closeModal();
      await getListApi({});
      setLoading(false);
      newId();
      form.resetFields();
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi thêm mới cấu hình lương");
    }

  };
  const editApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        id:data.id,// Lấy giá trị từ form
      };
       await employeeService.updateCauHinhLuong(params).then(res => {
         if(res.statusCode === 400)
         {
           Notification("error",res.message);
         }else
         {
           Notification("success","Đã sửa cấu hình lương thành công");
         }
       });

      setLoading(false);
      closeModal();
      await getListApi({});
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã xảy ra lỗi khi sửa cấu hình lương");
    }
  };
  useEffect(() => {

    form.setFieldsValue({
      ...data,
      thoiGianApDungTu: data?.thoiGianApDungTu
          ? dayjs(data.thoiGianApDungTu)
          : null,
      thoiGianApDungDen: data?.thoiGianApDungDen
          ? dayjs(data.thoiGianApDungDen)
          : null,

    });


  }, [data]);
  const onFinish = values => {
    if (type == "Thêm") {
      addApi();
    } else {
      editApi();
    }
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical">
            <Row gutter={[16, 8]}>

              <InputFields data={dataFields}></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button onClick={closeModal} style={{ backgroundColor: "red", borderColor: "red" , color: "white"  }}>Hủy bỏ</Button>
                  <Button htmlType="submit" type="primary" >
                   Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default FormAdd;
